/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · French (fr) · Contact page
   English is the source of truth in contact.html; this file supplies the
   French counterpart for each contact.* data-i18n key. Missing keys fall
   back to English automatically (see i18n.js).

   House voice: calm, exact, short. No em dashes (use periods, commas,
   or the mid-dot · ). Product names (Transderma C/A/O/M/R, Discovery
   Kit, Moisture Serum) and the postal address stay as-is. Informal
   singular "tu" throughout.
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.fr = window.TD_I18N.fr || {};
  Object.assign(window.TD_I18N.fr, {

    /* ── Footer · extra link not on the homepage ── */
    'footer.learn.about': 'À propos du Dr Ronlán',

    /* ── Page head ── */
    'contact.eyebrow': 'Prends contact',
    'contact.title': 'Questions,<br>demandes,<br><em>ou juste un bonjour.</em>',
    'contact.intro': 'Demandes presse, demandes revendeurs, questions sur la routine, ou n\'importe quoi entre les deux. Nous lisons chaque message. Les réponses arrivent généralement dans un délai de deux jours ouvrables.',

    /* ── Reach us ── */
    'contact.reach': 'Nous joindre',
    'contact.email.label': 'E-mail',
    'contact.email.meta': 'Idéal pour les questions détaillées',
    'contact.phone.label': 'Téléphone',
    'contact.phone.meta': 'Lun – ven · 9h–17h EST',
    'contact.address.label': 'Adresse',
    'contact.address.meta': 'Retours et correspondance',
    'contact.social.label': 'Retrouve-nous sur les réseaux sociaux',

    /* ── Inquiry form ── */
    'contact.form.eyebrow': 'Envoyer une demande',
    'contact.form.name': 'Nom',
    'contact.form.subject': 'Objet',
    'contact.form.email': 'Adresse e-mail',
    'contact.form.message': 'Message',
    'contact.form.send': 'Envoyer',
    'contact.form.success': 'Merci pour ton message · nous te répondons sous 1 à 2 jours ouvrables.',

    /* ── Response windows ── */
    'contact.hours.eyebrow': 'Délais de réponse',
    'contact.hours.email.label': 'E-mail',
    'contact.hours.email.val': 'Sous 2 jours ouvrables',
    'contact.hours.phone.label': 'Téléphone',
    'contact.hours.phone.val': '9h–17h EST',
    'contact.hours.press.label': 'Presse',
    'contact.hours.press.val': 'Sous 1 jour ouvrable',

    /* ── CTA ── */
    'contact.cta.title': 'Tu ne sais pas quel sérum te convient ?',
    'contact.cta.body': 'Le Discovery Kit contient les cinq sérums en format de poche. La plupart le savent en quelques jours.',
    'contact.cta.button': 'Obtenir le Discovery Kit'

  });
})();
